import React, { useState, useEffect } from "react";
import { Table, Alert, OverlayTrigger, Tooltip } from "react-bootstrap";

import SettingForm from "./setting-form";
import DeleteAlert from "./delete-alert";
import { PrimaryButton } from "../../../../components/TriyoButton/";

import {getAllSettings, deleteSetting} from "../../../../services/api/settings-api"
import { GetAllDepartmentsAPI } from '../../../../services/api/department-api';
import { GetEveryUser } from "../../../../services/api/user-api";
import DeleteIcon from "../../../../assets/icons/Icon - Delete File.svg";
import EditIcon from "../../../../assets/icons/Icon - Edit.svg";
import ViewIcon from "../../../../assets/icons/Icon - View.svg";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../redux/user/user-selector";
import NoPermissionTable from "../../../../components/no-permission-table/NoPermissionTable";

import './super-admin-settings-editor.scss';

const SettingEditor = () => {
  const blankSetting = {
    Id: 0,
    Name: "",
    CompanyId: 0,
    UserId: 0,
    Value: "",
    SubDepartment: ""
  };

  let searchQuery = {
    "pageSize": 100000,
    "pageNumber": 1,
    "sortDesc": false,
    "sortBy": "name",
    "filters": [],
 };

  const [allSettings, setAllSettings] = useState([]);
  const [currSetting, setCurrSetting] = useState({ ...blankSetting });
  const [open, setOpen] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [action, setAction] = useState("");
  const [settingIndex, setSettingIndex] = useState(-1);
  const [allDepartments, setAllDepartments] = useState([]);
  const [allUsers, setAllUsers] = useState([]);

  //alerts
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage , setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("");

  const user = useSelector(selectUser);
  const { privileges } = user;
  const canCreate = privileges["Settings Editor"]?.Add;
  const canEdit = privileges["Settings Editor"]?.Edit;
  const canViewDetails = privileges["Settings Editor"]?.Detail;
  const canDelete = privileges["Settings Editor"]?.Delete;

  const displayAlert = () => {
    const handleEnd = () => {
      setShowAlert(false);
      setAlertMessage("");
      setAlertVariant("");
    }

    window.setTimeout(()=>{ handleEnd()}, 4000);

    return (
      <Alert show={showAlert} onClose={() => handleEnd()} variant={alertVariant} dismissible>
        {alertMessage}
      </Alert>
    );
  }

  const getAllUsers = async() => {
    await GetEveryUser().then((usersResults) => {
        let users = [...usersResults];
        users.unshift({Id : 0, Name: "None", Active: 1});
        setAllUsers(users);
    })
    .catch((error) => {
        console.log(error);
        setAllUsers([]);
    })
  }

  const getAllDepartments = async() => {
    await GetAllDepartmentsAPI(searchQuery).then((departmentResults) => {
        let departments = [...departmentResults?.data?.dataList];
        departments.unshift({Id : 0, Name: "None", Active: 1});
        setAllDepartments(departments);
    })
    .catch((error) => {
        console.log(error);
        setAllDepartments([]);
    })
  }

  useEffect(()=>{
      // fetch settings
    const result = getAllSettings();
    result.then((response) => {
      // const reverseResp = response.reverse();
      // setAllSettings([...reverseResp]);
      setAllSettings([...response]);
    })
    .catch((error) =>{
      console.log(error);
    })

    // fetch Users
    getAllUsers();

    // fetch Companies/Departments
    getAllDepartments();
  }, []);

  const handleUpdate = (updatedSetting) => {
    let prevSettings = [...allSettings];
    prevSettings[settingIndex] = { ...updatedSetting };
    
    setAllSettings(prevSettings);
    setCurrSetting({ ...updatedSetting });

    //display error message
    setAlertMessage("Setting #" + settingIndex + " updated!")
    setAlertVariant("info")
    setShowAlert(true);
    handleClose();
  };

  const handleDelete = () => {
    let prevSettings = [...allSettings];
    const index = settingIndex;
    const Id = prevSettings[index].Id;
    prevSettings.splice(index, 1);

    const result = deleteSetting(Id);
    result.then(()=>{
        setAllSettings(prevSettings);
        setCurrSetting({ ...blankSetting });

        //display success
        setAlertMessage("Setting #" + index + " deleted!")
        setAlertVariant("info")
        setShowAlert(true);

        handleDeleteClose();
    })
    .catch((error) =>{
        //display error
        setAlertMessage("Could not delete setting!")
        setAlertVariant("danger")
        setShowAlert(true);

        console.log(error);
    })
  };

  const handleDeleteOpen = (index) => {
    setSettingIndex(index);
    setDeleteAlert(true);
    const chosenSetting = { ...allSettings[index] };
    setCurrSetting(chosenSetting);
  };

  const handleOpen = (triggerAction, index) => {
    if (triggerAction === "update" || triggerAction === "view") {
      const chosenSetting = { ...allSettings[index] };
      setCurrSetting(chosenSetting);
      setSettingIndex(index);
    } else {
      // add action
      setCurrSetting(blankSetting);
    }

    setAction(triggerAction);
    setSettingIndex(index);
    setOpen(true);
  };

  const handleAdd = (newSetting) => {
    let prevSettings = [...allSettings];
    //prevSettings.unshift(newSetting);
    prevSettings.push(newSetting);
    setAllSettings(prevSettings);

    // display new setting added message
    setAlertMessage("New Setting Added !")
    setAlertVariant("info")
    setShowAlert(true);
    handleClose();
  };

  const handleDeleteClose = () => {
    setDeleteAlert(false);
    handleClose();
  }

  const handleClose = () => {
    setAction("");
    setSettingIndex(-1);
    setCurrSetting({ ...blankSetting });
    setOpen(false);
  };

  return (
    <div className="tab-body">
      <div className="alert-window">{showAlert ? displayAlert(): <></>} </div>
      <div className="add-settings-row">
        {canCreate ? (
          <PrimaryButton
              onClick={() => {
                handleOpen("add", -1);
              }}
              disabled={!canCreate}
              text="Add New Setting"
              className="addButton"
          />
        ) : (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>You do not have the requisite Role Privileges to Add Setting Objects on TRIYO.</Tooltip>}
          >
            <span>
              <PrimaryButton
                  onClick={() => {
                    handleOpen("add", -1);
                  }}
                  disabled={!canCreate}
                  text="Add New Setting"
                  className="addButton"
              />
            </span>
          </OverlayTrigger>
        )}
      </div>    
      { canViewDetails ?
        <div className="table-body">
          <Table bordered hover responsive="sm">
              <thead>
              <tr className="settings-row" >
                  <th className="serial settings-column">#</th>
                  <th className="setting-name settings-column">Name</th>
                  <th className="setting-companyId settings-column">Company ID</th>
                  <th className="setting-userId settings-column">User ID</th>
                  <th className="setting-subDepartment settings-column">Sub-Department</th>
                  <th className="setting-value settings-column">Value</th>
                  <th className="setting-action settings-column">Action</th>
              </tr>
              </thead>
              <tbody>
              {allSettings &&
                  allSettings.map((setting, index) => {
                      return (
                          <tr key={index} className="settings-row">
                              <td className="serial settings-data">{index + 1}</td>
                              <td className="setting-name settings-data" >{setting.Name}</td>
                              <td className="setting-companyId settings-data">{setting.CompanyId}</td>
                              <td className="setting-userId settings-data">{setting.UserId}</td>
                              <td className="setting-subDepartment settings-data">{setting.SubDepartment}</td>
                              <td className="setting-value settings-data">{setting.Value}</td>
                              <td className="setting-action settings-data">
                                  <button
                                    className="actionButton"
                                    onClick= {() => {
                                      handleOpen(canEdit ? "update" : "view", index);
                                    }}
                                    name={canEdit ? "update" : "view"}
                                    value={index}
                                  >
                                    <img src={canEdit ? EditIcon : ViewIcon} alt={canEdit ? "Edit" : "View"} />
                                  </button>
                                  {canDelete ? (
                                    <button
                                      className="actionButton"
                                      onClick={() => {handleDeleteOpen(index)}}
                                      disabled = {!canDelete}
                                    >
                                      <img src={DeleteIcon} alt="Delete" />
                                    </button>
                                  ) : (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip>You do not have the requisite Role Privileges to Archive Setting Objects on TRIYO.</Tooltip>}
                                    >
                                      <span style={{ display: 'inline-block' }}>
                                        <button
                                          className="actionButton"
                                          onClick={() => {handleDeleteOpen(index)}}
                                          disabled = {!canDelete}
                                        >
                                          <img src={DeleteIcon} alt="Delete" />
                                        </button>
                                      </span>
                                    </OverlayTrigger>
                                  )}
                              </td>
                          </tr>
                      );
                  })
              }
              </tbody>
          </Table>
        </div>
        : <NoPermissionTable />
      }
        <SettingForm
          handleClose={handleClose}
          show={open}
          action={action}
          currSetting={{
            Id: currSetting.Id,
            Name: currSetting.Name,
            CompanyId: currSetting.CompanyId,
            UserId: currSetting.UserId,
            Value: currSetting.Value,
            SubDepartment: currSetting.SubDepartment
          }}
          handleUpdate={handleUpdate}
          handleAdd={handleAdd}
          allDepartments = {allDepartments}
          allUsers = {allUsers}
          canEdit = {canEdit}
        />
        <DeleteAlert 
          show= {deleteAlert}
          name = {currSetting.Name}
          handleClose = {handleDeleteClose}
          handleDelete = {handleDelete}
        />      
    </div>
  );
}

export default SettingEditor;
